/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    function updateCartCount() {
        var total = 0;
        document.querySelectorAll('#storeShoppingBag .cart_price_item').forEach(function (item) {
            if (item.dataset.unit === '100g') {
                total += 1;
            }
            else {
                total += parseInt(item.querySelector('.priceInfo .count').innerHTML);
            }
        });
        document.querySelector('.storeShoppingBagToggler .count .value').textContent = total.toString();
    }
    MoyaEventHandler.on('store.shopping-bag.update-toggler', function (e) {
        updateCartCount();
    });
    MoyaEventHandler.on('store.fetchBag', function (e) {
        updateCartCount();
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
